/**
 * (c) 2024, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
export const basepath = import.meta.env.BASE_URL ?? "/";

if (!basepath.endsWith("/")) {
  throw new Error("URL configuration broken: " + basepath);
}

export const createHomePageUrl = () => `${basepath}`;

export const createLegacyNewPageUrl = () => `${basepath}new`;

export const createProjectsPageUrl = () => `${basepath}projects`;

export const createImportPageUrl = () => `${basepath}import`;

export const createOpenSharedProjectPageUrl = () => `${basepath}:shareId`;

export const createDataSamplesPageUrl = () => `${basepath}data-samples`;

export interface TestingModelPageHistoryState {
  fromEditor?: boolean;
  focusVisible?: boolean;
}

export const createTestingModelPageUrl = () => `${basepath}testing-model`;

export const createCodePageUrl = () => `${basepath}code`;
